import { render, staticRenderFns } from "./modal-list-template-mail.vue?vue&type=template&id=88524c7c&scoped=true"
import script from "./modal-list-template-mail.vue?vue&type=script&lang=js"
export * from "./modal-list-template-mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88524c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88524c7c')) {
      api.createRecord('88524c7c', component.options)
    } else {
      api.reload('88524c7c', component.options)
    }
    module.hot.accept("./modal-list-template-mail.vue?vue&type=template&id=88524c7c&scoped=true", function () {
      api.rerender('88524c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/modal-list-template-mail.vue"
export default component.exports